export default __webpack_public_path__ + "static/media/8.7f20b3ef.jpg";